import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e8623ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "positioning-content" }
const _hoisted_2 = {
  key: 0,
  class: "information-container"
}
const _hoisted_3 = ["src"]

import { ref } from "vue";
import { IonContent, IonIcon, IonModal, IonText, modalController } from "@ionic/vue";
import { close } from "ionicons/icons"
import TaggedImage from "@/components/TaggedImage.vue";
import { Tag } from "@/types/frontendTypes";
import { getImageUrl } from "@/utils/FileUtils";


export default /*#__PURE__*/_defineComponent({
  __name: 'DetailsOverlay',
  props: {
    fontSizeTitle: null,
    tags: null,
    imageUrl: null
  },
  setup(__props: any) {

const props = __props as {
    fontSizeTitle: string;
    tags?: Tag[];
    imageUrl: string;
}



const tag = ref<Tag | null>()


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonModal), {
    trigger: "trigger-button",
    alignment: "top",
    class: "modal"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), { class: "modal-content" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(IonIcon), {
              icon: _unref(close),
              class: "close-icon",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(modalController).dismiss()))
            }, null, 8, ["icon"]),
            _createVNode(TaggedImage, {
              tags: __props.tags,
              src: __props.imageUrl,
              "open-tag": tag.value,
              "onUpdate:open-tag": _cache[1] || (_cache[1] = ($event: any) => ((tag).value = $event))
            }, null, 8, ["tags", "src", "open-tag"]),
            (tag.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("h1", {
                    class: _normalizeClass(["main-title", __props.fontSizeTitle])
                  }, _toDisplayString(tag.value.title), 3),
                  _createElementVNode("img", {
                    class: "detail-image",
                    src: _unref(getImageUrl)(tag.value.files[0]),
                    alt: ""
                  }, null, 8, _hoisted_3),
                  _createVNode(_unref(IonText), { style: {"color":"var(--ion-color-primary)"} }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(tag.value.description), 1)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})